<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div
    v-if="audienceLogic"
    id="edit_audienceLogic"
    class="container-fluid"
    :class="{ 'modal-logic': isModal, 'v-scroll': !isModal }">
    <div class="row">
      <div class="col-12">
        <div class="form-horizontal">
          <div
            v-if="!isModal"
            class="form-section group flex-h">
            <span class="icon">
              <icon-colored-audienceLogic />
            </span>
            <span
              v-if="isNew"
              style="flex-grow: 1"
              >{{ capitalize($t('names.newAudienceLogic', { n: 1 })) }}</span
            >
            <span
              v-else
              style="flex-grow: 1"
              >{{ capitalize($t('actions.editAudienceLogic')) }} &quot;{{ name }}&quot;</span
            >
          </div>
          <div
            class="form-section-content"
            :class="{ 'mt-4': isModal }">
            <!-- NAME -->
            <div class="form-group row">
              <form-label
                for-i-d="edit_audienceLogic_name"
                :is-required="true"
                >{{ capitalize($t('names.name', { n: 1 })) }}
              </form-label>
              <div class="col-sm-8">
                <input
                  id="edit_audienceLogic_name"
                  v-model="name"
                  name="name"
                  type="text"
                  :class="{
                    'form-control': true,
                    input: true,
                    'is-danger': $validator.messageBag.errors.has('name'),
                  }" />
                <span
                  v-show="$validator.messageBag.errors.has('name')"
                  class="help is-danger"
                  >{{ $validator.messageBag.errors.first('name') }}</span
                >
              </div>
            </div>
          </div>

          <!-- SUMMARY -->
          <audience-logic-summary
            v-show="audienceLogic.audienceRules.length > 0"
            :show-form-separator="isModal"
            :show-pane="!isModal"
            :audience-logic="audienceLogic" />

          <!-- RULES -->
          <form-separator
            v-if="isModal"
            margin-size="sm">
            <template #icon>
              <icon-colored-audience-rule />
            </template>
            <span>{{ capitalize($t('names.audienceRule', { n: 2 })) }}</span>
          </form-separator>
          <div
            v-else
            class="form-section group">
            <span class="icon"><icon-colored-audience-rule /></span>
            <span>{{ capitalize($t('names.audienceRule', { n: 2 })) }}</span>
          </div>

          <div class="form-section-content pb-5">
            <audience-group-node
              v-if="!isDeletingAudienceRule"
              v-show="expressionTree.nodes.length"
              ref="audienceLogicNode"
              :group="expressionTree"
              :is-editable="true"
              :geofence-groups="geofenceGroups"
              :inline-popups="isModal" />
            <div v-show="!expressionTree.nodes.length">
              <div class="empty-state">
                <icon-complex-rule />
                <div
                  v-if="organizationSettings.enableGenAIAudienceRecommendation && !isEditingManually"
                  class="audience-ai-prompt">
                  <div class="header">{{ $t('messages.audienceLogicExpressionAIPrompt') }}</div>
                  <audience-rule-prompt @suggested="onSegmentsSuggested" />
                  <div class="badge badge-info">{{ uppercase($t('conjuctions.or')) }}</div>
                  <button
                    class="btn btn-default"
                    name="buildManually"
                    @click="isEditingManually = true">
                    {{ $t('messages.manualCustomAudience') }}
                  </button>
                </div>
                <div v-else>
                  <div class="header">{{ $t('messages.audienceLogicExpressionEmptyStateTitle') }}</div>
                  <div class="details">
                    <div class="actions">
                      <button
                        class="btn btn-default"
                        name="addGroup"
                        @click="addGroup">
                        {{ $t('actions.addGroup') }}
                      </button>
                      <button
                        v-if="showEpsilonSegment"
                        class="btn btn-default"
                        name="addEpsilonSegmentRule"
                        @click="addEpsilonSegmentRule">
                        {{ $t('actions.addEpsilonSegmentRule') }}
                      </button>
                      <button
                        v-if="showAdsquareSegment"
                        class="btn btn-default"
                        name="addAdsquareSegmentRule"
                        @click="addAdsquareSegmentRule">
                        {{ $t('actions.addAdsquareSegmentRule') }}
                      </button>
                      <button
                        v-if="showMastercardSegment"
                        class="btn btn-default"
                        name="addMastercardSegmentRule"
                        @click="addMastercardSegmentRule">
                        {{ $t('actions.addMastercardSegmentRule') }}
                      </button>
                      <button
                        v-if="showPredefinedSegment"
                        class="btn btn-default"
                        name="addLifesightSegmentRule"
                        @click="addLifesightSegmentRule">
                        {{ $t('actions.addPredefinedSegmentRule') }}
                      </button>
                      <button
                        v-if="showLiverampRule"
                        class="btn btn-default"
                        name="addLiverampSegmentRule"
                        @click="addLiverampSegmentRule">
                        {{ $t('actions.addLiverampSegmentRule') }}
                      </button>
                      <button
                        class="btn btn-default"
                        name="addDemographicsRules"
                        @click="addDemographicsRules">
                        {{ $t('actions.addPredefinedDemographicRules') }}
                      </button>
                      <button
                        v-if="organizationSettings?.uiEnableGeofenceGroupsRulesInAudienceLogics"
                        class="btn btn-default"
                        name="addGeofenceGroupRule"
                        @click="addRule">
                        {{ $t('actions.addRule') }}
                      </button>
                      <button
                        v-if="organizationSettings?.uiEnableCustomAudienceExternalDemographics"
                        class="btn btn-default"
                        name="addCustomAudienceRule"
                        @click="addRuleDemo">
                        {{ $t('actions.addRuleDemo') }}
                      </button>

                      <button
                        class="btn btn-default"
                        name="addAudienceDeviceIDGroup"
                        @click="addDeviceIDSegmentRule">
                        {{ $t('actions.addDeviceIDSegmentRule') }}
                      </button>
                    </div>
                  </div>
                  <template v-if="organizationSettings.enableGenAIAudienceRecommendation">
                    <div class="badge badge-info mt-4">{{ uppercase($t('conjuctions.or')) }}</div>
                    <a-i-wrapper class="mt-4">
                      <button
                        class="btn btn-primary-hollow"
                        name="useAI"
                        @click="isEditingManually = false">
                        <magic-wand style="margin-right: 1.2rem" />
                        {{ $t('messages.aiCustomAudience') }}
                      </button>
                    </a-i-wrapper>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <!-- FOOTER -->
          <save-and-cancel
            class="save-footer"
            entity-type="audienceLogic"
            :disable-floating="true"
            @cancel="cancel"
            :save-button-disabled="audienceLogic?.hasMastercardRule"
            @save="save" />
        </div>
      </div>
    </div>
    <modal
      :id="saveChangesConfirmationModalID"
      :visible="isSaveChangesModalVisible"
      :title="saveChangesConfirmationModalTitle"
      :body="saveChangesConfirmationModalBody"
      :button1-caption="yes"
      :button2-caption="no"
      :button2-visible="true"
      @confirmed="saveChangesModalConfirmed"
      @cancelled="saveChangesModalCancelled" />
    <confirm-losing-changes-modal
      :is-visible="isConfirmLosingChangesModalVisible"
      :confirm-callback="confirmLosingChangesCallback"
      @confirmed="
        () => {
          isConfirmLosingChangesModalVisible = false;
        }
      "
      @cancelled="
        () => {
          isConfirmLosingChangesModalVisible = false;
        }
      " />
  </div>
</template>

<script type="text/babel">
  import antlr4 from 'antlr4';
  import { DateTime } from 'luxon';
  import numbro from 'numbro';
  import { capitalize, computed, unref } from 'vue';
  import { mapActions, mapGetters, mapState } from 'vuex';

  import AIWrapper from '@/common/components/AIWrapper.vue';
  import { ConfirmLosingChangesModal, FormLabel, SaveAndCancel } from '@/common/components/controls';
  import FormSeparator from '@/common/components/controls/FormSeparator.vue';
  import { AudienceLogicTypes } from '@/common/enums/audience-logic-types';
  import { AudienceRuleModes, isExternalSegmentRule } from '@/common/enums/audience-rule-modes';
  import { DataMarketplaceCodes } from '@/common/enums/data-marketplace-codes.enum';
  import { DataProviderCodes, isLifesightDataProvider } from '@/common/enums/data-provider-codes';
  import {
    IconColoredAudienceLogic,
    IconColoredAudienceRule,
    IconColoredDataPoints,
    IconColoredMobilePhone,
  } from '@/common/icons/colored';
  import { IconComplexRule } from '@/common/icons/complex';
  import MagicWand from '@/common/icons/monochrome/MagicWand.vue';
  import { AudienceLogic } from '@/common/models';
  import AudienceGroup from '@/common/models/audience/AudienceGroup';
  import AudienceRule from '@/common/models/audience/AudienceRule';
  import AudienceRuleCustomGroup from '@/common/models/audience/AudienceRuleCustomGroup';
  import MastercardAudienceLogic from '@/common/models/audience/MastercardAudienceLogic';
  import GeofenceGroupType from '@/common/models/geofenceGroups/GeofenceGroupType.enum';
  import Filter from '@/common/models/query-params/Filter';
  import FilterCollection from '@/common/models/query-params/FilterCollection';
  import * as FilterComparisonOperator from '@/common/models/query-params/FilterComparisonOperator';
  import QueryParams from '@/common/models/query-params/QueryParams';
  import GlobalEventBus from '@/GlobalEventBus';
  import GlobalEvents from '@/GlobalEvents';
  import { isValidURL, uniq, uppercase } from '@/globals';
  import AudienceLogicSummary from '@/org-app/components/audienceLogics/AudienceLogicSummary.vue';
  import AudienceGroupNode from '@/org-app/components/audienceRules/AudienceGroupNode.vue';
  import AudienceRulePrompt from '@/org-app/components/audienceRules/AudienceRulePrompt.vue';
  import { useDataProviders } from '@/org-app/services/tanstack/queries';
  import { useDataMarketplaces } from '@/org-app/services/tanstack/queries/dataMarketplaces.queries';
  import { queryKeys } from '@/org-app/services/tanstack/queryKeys';
  import queryClient, { waitForPendingQueries } from '@/org-app/services/tanstack/queryUtils';
  import { AudienceLogicLexer } from '@/utils/antlr4/AudienceLogicLexer';
  import { AudienceLogicListener } from '@/utils/antlr4/AudienceLogicListener';
  import { AudienceLogicParser } from '@/utils/antlr4/AudienceLogicParser';
  import AudienceSegmentUtils from '@/utils/AudienceSegmentUtils';
  import UserNotifications from '@/utils/UserNotifications';
  import i18n from '@/vueI18n';

  export default {
    components: {
      AudienceRulePrompt,
      AIWrapper,
      MagicWand,
      AudienceGroupNode,
      FormSeparator,
      AudienceLogicSummary,
      ConfirmLosingChangesModal,
      FormLabel,
      IconColoredAudienceLogic,
      IconColoredAudienceRule,
      IconComplexRule,
      SaveAndCancel,
    },
    props: {
      audienceLogicId: {
        type: String,
        default: null,
      },
      isModal: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        audienceLogic: null,
        newAudienceDeviceIDGroup: [],
        confirmLosingChangesCallback: null,
        demographics: [],
        externalDemographics: [],
        entityTimestamp: DateTime.local(),
        expressionTree: [],
        formulaPaneHeight: 0,
        geofenceGroups: [],
        isDeletingAudienceRule: false,
        isLoadingDataProviders: false,
        isFormulaPanelFloating: false,
        isSaveChangesModalVisible: false,
        isConfirmLosingChangesModalVisible: false,
        saveChangesConfirmationModalID: 'edit_audienceLogic_save_changes_confirmation_modal',
        selectedExternalDemographics: {},
        selectedAudienceDeviceIDGroups: [],
        selectedGeofenceGroups: [],
        didDetectUnexpectedChanges: false,
        showEpsilonSegment: false,
        showAdsquareSegment: false,
        showMastercardSegment: false,
        showPredefinedSegment: true,
        AudienceRuleModes,
        IconColoredMobilePhone,
        IconColoredDataPoints,
        geofenceModalId: null,
        geofenceModalRuleKey: null,
        isGeofenceModalShowing: false,
        isEditingManually: false,
        dataMarketplaceQuery: useDataMarketplaces(),
        dataProviderQuery: useDataProviders(),
      };
    },
    computed: {
      ...mapGetters('orgApp', ['enableAudienceGeoStatistics']),
      ...mapState('orgApp', {
        organization: (state) => state.organization,
        organizationSettings: (state) => state.organizationSettings,
      }),
      name: {
        get() {
          return this.audienceLogic.name;
        },
        set(value) {
          this.updateAudienceLogicName({ audienceLogic: this.audienceLogic, value });
        },
      },
      externalDemographicIDs: {
        get() {
          return this.audienceLogic.externalDemographicIDs;
        },
        set(value) {
          this.updateAudienceLogicExternalDemographicIDs({ audienceLogic: this.audienceLogic, value });
        },
      },
      isNew() {
        return this.audienceLogicId === 'new';
      },
      selectedDataProvider() {
        let dataProvider;
        if (this.audienceLogic?.dataProviderID) {
          dataProvider = this.dataProviders.find((dp) => dp.id === this.audienceLogic.dataProviderID);
        }
        if (!dataProvider) {
          dataProvider = this.dataProviders.find(isLifesightDataProvider);
        }
        return dataProvider;
      },
      no() {
        return capitalize(i18n.global.t('actions.no'));
      },
      yes() {
        return capitalize(i18n.global.t('actions.yes'));
      },
      saveChangesConfirmationModalTitle() {
        const message = this.isNew ? 'saveNewEntity' : 'saveChanges';
        return capitalize(i18n.global.t(`actions.${message}`));
      },
      saveChangesConfirmationModalBody() {
        const message = this.isNew ? 'confirmSaveNewEntity' : 'confirmSaveChanges';
        return capitalize(i18n.global.t(`messages.${message}`));
      },
      currencySymbol() {
        return numbro.languageData().currency.symbol;
      },
      geofences() {
        return this.selectedGeofenceGroups == null
          ? []
          : this.selectedGeofenceGroups.reduce((m, x) => [...m, ...x.geofences], []);
      },
      dataMarketplaces() {
        return unref(this.dataMarketplaceQuery.items);
      },
      dataProviders() {
        return unref(this.dataProviderQuery.items);
      },
      showLiverampRule() {
        const liveboardMarketplace = this.dataMarketplaces.find((dm) => dm.code === DataMarketplaceCodes.LIVERAMP);
        if (liveboardMarketplace) {
          return this.dataProviders.some((dp) => dp.dataMarketplaceID === liveboardMarketplace.id);
        }
        return false;
      },
    },
    methods: {
      uppercase,
      ...mapActions([
        'updateAudienceLogicName',
        'updateAudienceLogicDataProviderID',
        'updateAudienceLogicDataMarketplaceID',
        'updateAudienceLogicExternalDemographicIDs',
        'updateAudienceLogicLogicalExpression',
        'updateAudienceLogicAudienceRules',
        'updateAudienceRuleKey',
        'updateAudienceRuleName',
        'updateDataProviderExternalDemographics',
        'updateDataProviderSelectedExternalDemographics',
      ]),
      ...mapActions('orgApp', [
        'createNewAudienceLogic',
        'createAudienceRuleCustomGroup',
        'getAllExternalDemographics',
        'getExternalDemographics',
        'getAudienceLogic',
        'getGeofenceGroups',
        'getAudienceRuleCustomGroups',
        'getLifesightAudienceSegmentsByOrg',
        'getExternalSegmentsByOrg',
        'getOrganizationSettings',
        'createAudienceLogics',
        'createMastercardAudienceLogics',
        'updateAudienceLogic',
        'getAudienceRuleCustomGroup',
        'getLifesightAudienceSegmentsByOrg',
        'getAllLifesightSegments',
      ]),
      capitalize(text) {
        return capitalize(text);
      },
      onSegmentsSuggested(segments) {
        segments.forEach((segment) => {
          const rule = AudienceRule.fromObject({
            mode: AudienceRuleModes.Segments,
            parent: this.expressionTree,
            name: segment.name,
            audienceRuleCustomGroup: new AudienceRuleCustomGroup(segment.name, segment.s3Path),
            segments: [segment],
          });
          this.expressionTree.nodes.push(rule);
          GlobalEventBus.$emit(GlobalEvents.addAudienceLogicRule, rule);
        });
      },
      async updateGeofenceGroup(geofenceGroupId) {
        // Update geofence groups since we changed one
        if (geofenceGroupId) {
          this.geofenceGroups = (
            await this.getGeofenceGroups({
              queryParams: QueryParams.all(
                new FilterCollection([new Filter('usage_id', [GeofenceGroupType.AUDIENCE])]),
              ),
            })
          ).items;
        }
      },
      async save() {
        // Update externalDemographicIDs
        const { selectedExternalDemographics } = this;
        this.externalDemographicIDs = this.dataProviders
          .map((x) => (selectedExternalDemographics[x] != null ? selectedExternalDemographics[x].map((y) => y.id) : []))
          .flat();

        const extras = {};
        const validationPromises = [this.$validator.validateAll(this.audienceLogic, extras)];
        const audienceRuleNodes = this.getAudienceRuleNodes();

        const shouldPopulateDeviceGroup = (mode) =>
          isExternalSegmentRule(mode) || mode === AudienceRuleModes.Demographic;

        if (audienceRuleNodes.length > 0) {
          audienceRuleNodes.forEach((component) => {
            const { audienceRuleCustomGroup, audienceRule } = component;
            const { s3Path } = audienceRuleCustomGroup;
            if (s3Path != null) {
              const isS3Path = s3Path.startsWith('s3');
              const validationRules = {};
              if (shouldPopulateDeviceGroup(audienceRule.mode) && audienceRule.isAudienceDeviceIDGroup) {
                if (s3Path?.trim() === '') {
                  validationRules[`S3Path_${component.audienceRule.key}`] = {
                    message:
                      audienceRule.mode === AudienceRuleModes.Segments
                        ? i18n.global.t('messages.segmentIsRequired')
                        : i18n.global.t('messages.s3PathFieldIsRequired'),
                    preEvaluated: true,
                  };
                }
                if (s3Path?.trim() !== '' && !isValidURL(s3Path) && !isS3Path) {
                  validationRules[`S3Path_${component.audienceRule.key}`] = {
                    message: i18n.global.t('messages.s3PathURLIsInvalid'),
                    preEvaluated: true,
                  };
                }

                const ids = [
                  audienceRule.geofenceGroupID,
                  audienceRule.customGroupID,
                  audienceRule.externalDemographicID,
                ];
                if (ids.filter((id) => id !== null && id !== undefined)?.length > 1) {
                  validationRules[`customId_${audienceRule.key}`] = {
                    message: `${audienceRule.name}: ${i18n.global.t('messages.ruleShouldOnlyHaveOneId')}`,
                    preEvaluated: true,
                  };
                }

                component.$validator.init(new AudienceRuleCustomGroup());
                validationPromises.push(component.$validator.validateAll(audienceRuleCustomGroup, validationRules));
              }
            }
          });
        } else {
          UserNotifications.error({
            title: i18n.global.t('messages.failedToSaveAudienceLogic'),
            message: i18n.global.t('messages.audienceLogicEmptyRules'),
          });
          return;
        }

        // having () in the logical expression means we have an empty group, don't let the user save an empty group
        if (this.audienceLogic.logicalExpression.indexOf('()') > -1) {
          UserNotifications.error({
            title: i18n.global.t('messages.failedToSaveAudienceLogic'),
            message: i18n.global.t('messages.audienceLogicEmptyGroup'),
          });
          return;
        }

        for await (const x of this.audienceLogic.audienceRules) {
          if (x.mode === AudienceRuleModes.Geofence) {
            const geofenceGroup = this.geofenceGroups.find((group) => group.id === x.geofenceGroupID);
            if (geofenceGroup != null) {
              x.name = geofenceGroup.name;
            }
          }
          const specificRules = x.getExtraValidationRules();
          validationPromises.push(this.$validator.validateAll(x, specificRules, true));
          if (
            (x.mode === AudienceRuleModes.Geofence ||
              x.mode === AudienceRuleModes.Segments ||
              x.mode === AudienceRuleModes.Demographic) &&
            x.isAudienceDeviceIDGroup
          ) {
            const audienceLookbackWindowRules = x.audienceLookbackWindow.getExtraValidationRules();
            validationPromises.push(
              this.$validator.validateAll(x.audienceLookbackWindow, audienceLookbackWindowRules, true),
            );
          }
        }

        Promise.all(validationPromises).then(
          () => {
            if (this.entityTimestamp.equals(this.audienceLogic.timestamp)) {
              this.exit();
            } else if (this.audienceLogic.id === -1) {
              this.saveChangesModalConfirmed();
            } else {
              this.isSaveChangesModalVisible = true;
            }
          },
          () => {
            let message = `${i18n.global.t('messages.failedToSaveAudienceLogic')} ${this.$validator.messageBag.htmlErrorList}`;
            const audienceRuleNodeErrorMessages = this.getAudienceRuleNodeErrorMessages();
            if (audienceRuleNodeErrorMessages.length > 1) {
              message = message.concat(audienceRuleNodeErrorMessages);
            }

            UserNotifications.error({
              title: i18n.global.t('messages.missingRequiredValue'),
              message,
            });
          },
        );
      },
      cancel() {
        this.exit();
      },
      exit(audienceLogic) {
        if (this.isModal) {
          this.$emit(
            'complete',
            audienceLogic?.demographicID > 0 ? audienceLogic.demographicID : this.audienceLogic.demographicID,
          );
        } else if (audienceLogic?.id > 0 || this.audienceLogic.id > 0) {
          this.$router.push(`/audiences/${audienceLogic?.id > 0 ? audienceLogic.id : this.audienceLogic.id}`);
        } else {
          this.$router.push('/audiences');
        }
      },
      async updateAudienceRulesNode() {
        const audienceRuleNodes = this.getAudienceRuleNodes();
        if (audienceRuleNodes.length === 0) {
          return;
        }
        for await (const ruleNode of audienceRuleNodes) {
          const { audienceRule } = ruleNode;
          const shouldPopulateDeviceGroup =
            (isExternalSegmentRule(audienceRule.mode) &&
              !this.selectedDataProvider?.code === DataProviderCodes.MASTERCARD) ||
            audienceRule.mode === AudienceRuleModes.Demographic;
          if (shouldPopulateDeviceGroup && audienceRule.isAudienceDeviceIDGroup) {
            const { customGroupID } = audienceRule;
            if (customGroupID == null || customGroupID < 0) {
              const [newAudienceDeviceIDGroup] = await ruleNode.save();
              this.audienceLogic.audienceRules.forEach((x) => {
                if (x.key === ruleNode.audienceRule.key) {
                  x.customGroupID = newAudienceDeviceIDGroup.customGroupID;
                }
              });
            } else {
              ruleNode.update();
            }
          }
        }
      },
      async saveChangesModalConfirmed() {
        let audienceLogic = null;
        await this.updateAudienceRulesNode();

        // check demographics parameters
        const demoRules = this.audienceLogic.audienceRules.filter(
          (rule) => rule.mode === AudienceRuleModes.PredefinedDemographic,
        );
        const demoRulesWithParameters = demoRules.filter((rule) => rule.segments?.length);

        if (demoRules.length !== demoRulesWithParameters.length) {
          UserNotifications.error({
            title: i18n.global.t('messages.failedToSaveAudienceLogic'),
            message: i18n.global.t('messages.refineYourDemographicsParameters'),
          });
          return;
        }

        const { audienceRules, logicalExpression } = AudienceSegmentUtils.audienceLogicFeToBe(this.audienceLogic);
        this.audienceLogic.audienceRules = audienceRules;

        const instances = {};
        for await (const [index, rule] of this.audienceLogic.audienceRules.entries()) {
          // we need to create the custom group id for the new external segment rule we added previously before saving the logic
          const isPredefinedDemographicRule = rule.mode === AudienceRuleModes.PredefinedDemographic;
          const isMastercardProvider = this.selectedDataProvider?.code === DataProviderCodes.MASTERCARD;
          if (isPredefinedDemographicRule || (isExternalSegmentRule(rule.mode) && !isMastercardProvider)) {
            instances[index] = new AudienceRuleCustomGroup(
              rule.name,
              rule.audienceRuleCustomGroup?.s3Path,
              this.organization.id,
              rule.audienceRuleCustomGroup?.externalSegmentID ?? -1,
            );
          }
        }
        const instancesValues = Object.values(instances);
        if (instancesValues?.length) {
          const newAudienceRuleCustomGroups = await this.createAudienceRuleCustomGroup({
            instances: instancesValues,
          });
          Object.keys(instances).forEach((key, index) => {
            this.audienceLogic.audienceRules[key].customGroupID = newAudienceRuleCustomGroups[index].customGroupID;
          });
        }

        if (this.isNew) {
          // Mastercard has its own endpoint to save
          if (this.selectedDataProvider?.code === DataProviderCodes.MASTERCARD) {
            const segmentIDs = this.audienceLogic.audienceRules
              .filter((r) => r.mode === AudienceRuleModes.Segments)
              .map((r) => r.segment?.externalSegmentId)
              .filter((v) => !!v);
            audienceLogic = await this.createMastercardAudienceLogics({
              instances: MastercardAudienceLogic.fromObject({
                name: this.audienceLogic.name,
                segmentIDs,
              }),
            });
          } else {
            audienceLogic = await this.createAudienceLogics({
              instances: AudienceLogic.fromObject({
                ...this.audienceLogic,
                dataProviderID: this.audienceLogic.dataProviderID ?? this.dataProviders[0].id,
                logicalExpression,
              }),
            });
          }
        } else {
          audienceLogic = await this.updateAudienceLogic({
            instance: AudienceLogic.fromObject({ ...this.audienceLogic, logicalExpression }),
          });
        }

        this.entityTimestamp = DateTime.fromISO(this.audienceLogic.timestamp);
        await queryClient.invalidateQueries({ queryKey: [queryKeys.demographics], refetchType: 'active' });
        this.exit(audienceLogic);
        UserNotifications.success({
          title: capitalize(i18n.global.t('names.success', { n: 1 })),
          message: i18n.global.t('messages.audienceLogicSavedSuccessfully'),
        });
      },
      saveChangesModalCancelled() {
        this.isSaveChangesModalVisible = false;
      },
      addAudienceRule(rule) {
        const newAudienceRulesKeys = this.audienceLogic?.audienceRules?.length
          ? [...this.audienceLogic.audienceRules.map((a) => a.key)]
          : [];
        const oldAudienceRulesKeys = this.audienceLogic?.apiObject?.audiencerules?.length
          ? [...this.audienceLogic.apiObject.audiencerules.map((a) => a.key)]
          : [];
        const keys = uniq([...newAudienceRulesKeys, ...oldAudienceRulesKeys]);
        const key = keys?.length ? Math.max(...keys) + 1 : 1;

        this.updateAudienceRuleKey({
          audienceRule: rule,
          value: key,
        });
        if (rule.name == null) {
          this.updateAudienceRuleName({
            audienceRule: rule,
            value: `Rule #${rule.key}`,
          });
        }

        this.updateAudienceLogicAudienceRules({
          audienceLogic: this.audienceLogic,
          value: [...this.audienceLogic.audienceRules, rule],
        });

        this.updateDataProvider();
        this.updateLogicalExpression();
      },
      deleteAudienceRule(rule) {
        this.updateAudienceLogicAudienceRules({
          audienceLogic: this.audienceLogic,
          value: this.audienceLogic.audienceRules.filter((x) => x.key !== rule.key),
        });

        this.updateLogicalExpression();
      },
      updateDataProvider() {
        const externalRule = this.audienceLogic.audienceRules.find((r) => isExternalSegmentRule(r.mode));
        if (externalRule) {
          if (externalRule.dataProviderID) {
            this.updateAudienceLogicDataProviderID({
              audienceLogic: this.audienceLogic,
              value: externalRule.dataProviderID,
            });
          }
        }
      },
      updateLogicalExpression() {
        const processNode = (node, expression, topLevel) => {
          const operator = node.parent?.operator?.value ?? '|';
          if (node.nodes !== undefined) {
            // group
            if (expression.length && expression.slice(-1) !== '(') {
              expression = `${expression}${operator}`;
            }
            if (node.isNegated) {
              expression = `${expression}!`;
            }
            if (!topLevel) {
              expression = `${expression}(`;
            }
            node.nodes.forEach((childNode) => {
              expression = processNode(childNode, expression, false);
            });
            if (!topLevel) {
              expression = `${expression})`;
            }
          } else {
            // rule
            if (expression.length && expression.slice(-1) !== '(') {
              expression = `${expression}${operator}`;
            }
            if (node.isNegated) {
              expression = `${expression}!${node.key}`;
            } else {
              expression = `${expression}${node.key}`;
            }
          }
          return expression;
        };

        const logicalExpression = processNode(this.expressionTree, '', true);

        this.updateAudienceLogicLogicalExpression({
          audienceLogic: this.audienceLogic,
          value: logicalExpression,
        });
      },
      addRule() {
        this.$refs.audienceLogicNode.addRule(AudienceRuleModes.Geofence);
      },
      async addEpsilonSegmentRule() {
        await this.updateAudienceLogicDataProviderID({
          audienceLogic: this.audienceLogic,
          value: this.dataProviders.find((dp) => dp.code === DataProviderCodes.EPSILON).id,
        });
        this.$refs.audienceLogicNode.addRule(AudienceRuleModes.Epsilon);
      },
      async addLifesightSegmentRule() {
        await this.updateAudienceLogicDataProviderID({
          audienceLogic: this.audienceLogic,
          value: this.dataProviders.find(isLifesightDataProvider).id,
        });
        this.$refs.audienceLogicNode.addRule(AudienceRuleModes.Segments);
      },
      async addAdsquareSegmentRule() {
        await this.updateAudienceLogicDataProviderID({
          audienceLogic: this.audienceLogic,
          value: this.dataProviders.find((dp) => dp.code === DataProviderCodes.ADSQUARE).id,
        });
        this.$refs.audienceLogicNode.addRule(AudienceRuleModes.Segments);
      },
      async addMastercardSegmentRule() {
        await this.updateAudienceLogicDataProviderID({
          audienceLogic: this.audienceLogic,
          value: this.dataProviders.find((dp) => dp.code === DataProviderCodes.MASTERCARD).id,
        });
        this.$refs.audienceLogicNode.addRule(AudienceRuleModes.Segments);
      },
      async addLiverampSegmentRule() {
        await this.updateAudienceLogicDataMarketplaceID({
          audienceLogic: this.audienceLogic,
          value: this.dataMarketplaces.find((dp) => dp.code === DataMarketplaceCodes.LIVERAMP).id,
        });
        this.$refs.audienceLogicNode.addRule(AudienceRuleModes.Segments);
      },
      addDemographicsRules() {
        this.$refs.audienceLogicNode.addRule(AudienceRuleModes.PredefinedDemographic);
      },
      addDeviceIDSegmentRule() {
        this.$refs.audienceLogicNode.addRule(AudienceRuleModes.Demographic);
      },
      addRuleDemo() {
        this.$refs.audienceLogicNode.addRule(AudienceRuleModes.Demographic);
      },
      addGroup() {
        this.$refs.audienceLogicNode.addGroup();
      },
      async fetchGeofenceGroups() {
        const geofenceGroupIDs = this.audienceLogic.audienceRules
          .filter((x) => x.geofenceGroupID != null)
          .map((x) => x.geofenceGroupID)
          .reduce((m, x) => (m.indexOf(x) === -1 ? [...m, x] : m), []); // unique
        if (geofenceGroupIDs.length === 0) {
          return;
        }

        const geofenceGroups = await this.getGeofenceGroups({
          queryParams: QueryParams.for({
            expand: ['geofences'],
            filterCollection: new FilterCollection([
              new Filter('geofencegroup_id', geofenceGroupIDs, FilterComparisonOperator.IN),
            ]),
          }),
        });
        this.selectedGeofenceGroups = geofenceGroups.items;
      },
      async fetchAudienceCustomGroups() {
        if (this.isNew) {
          const response = await this.getAudienceRuleCustomGroups({
            queryParams: QueryParams.for({
              top: 10,
              filterCollection: new FilterCollection([
                new Filter('organization_id', [this.organization.id], FilterComparisonOperator.IN),
              ]),
              sort: 'customgroup_id desc',
            }),
          });
          this.newAudienceDeviceIDGroup = response.items;
        } else {
          const audienceDeviceGroupIDs = this.audienceLogic.audienceRules
            .filter((x) => x.customGroupID != null)
            .map((x) => x.customGroupID);
          const uniqueAudienceDeviceGroupIDs = [...new Set(audienceDeviceGroupIDs)];
          if (uniqueAudienceDeviceGroupIDs.length === 0) {
            return;
          }

          const audienceDeviceIDGroups = await this.getAudienceRuleCustomGroups({
            queryParams: QueryParams.for({
              filterCollection: new FilterCollection([
                new Filter('customgroup_id', uniqueAudienceDeviceGroupIDs, FilterComparisonOperator.IN),
              ]),
            }),
          });
          this.selectedAudienceDeviceIDGroups = audienceDeviceIDGroups.items;
        }
      },
      getAudienceRuleNodes() {
        let audienceRuleNodes = [];

        const getAudienceLogicChildNode = (parentNode) => {
          if (parentNode?.childRefs?.length) {
            parentNode.childRefs.forEach((childNode) => {
              if (childNode.type === AudienceLogicTypes.Rule) {
                audienceRuleNodes = audienceRuleNodes.concat(childNode.innerRef);
              } else {
                getAudienceLogicChildNode(childNode.innerRef);
              }
            });
          }
        };

        if (this.$refs) {
          getAudienceLogicChildNode(this.$refs.audienceLogicNode);
        }

        return audienceRuleNodes.filter((node) =>
          this.audienceLogic.audienceRules.some((n) => n.key === node?.audienceRule?.key),
        );
      },
      getAudienceRuleNodeErrorMessages() {
        const audienceRuleNodes = this.getAudienceRuleNodes();
        if (audienceRuleNodes.length < 0) {
          return null;
        }

        let errorMessages = '';
        audienceRuleNodes.forEach((x) => {
          errorMessages = errorMessages.concat(`${x.$validator.messageBag.htmlErrorList}`);
          x.$forceUpdate();
        });
        return errorMessages;
      },
      async fetchDataProviders() {
        await waitForPendingQueries([this.dataProviderQuery]);
        this.showPredefinedSegment = this.dataProviders.some(isLifesightDataProvider);
        this.showEpsilonSegment = this.dataProviders.some((dp) => dp.code === DataProviderCodes.EPSILON);
        this.showAdsquareSegment = this.dataProviders.some((dp) => dp.code === DataProviderCodes.ADSQUARE);
        this.showMastercardSegment = this.dataProviders.some((dp) => dp.code === DataProviderCodes.MASTERCARD);
      },
    },
    watch: {
      audienceLogic(val) {
        if (val !== null) {
          const chars = new antlr4.InputStream(val.logicalExpression);
          const lexer = new AudienceLogicLexer(chars);
          const tokens = new antlr4.CommonTokenStream(lexer);
          const parser = new AudienceLogicParser(tokens);
          const tree = new AudienceGroup();
          const listener = new AudienceLogicListener(val.audienceRules, tree);
          parser.addParseListener(listener);
          parser.parse();
          this.expressionTree = tree;
        }
      },
    },
    provide() {
      return {
        audienceLogic: computed(() => this.audienceLogic),
      };
    },
    async beforeMount() {
      await this.fetchDataProviders();

      if (this.organizationSettings === null) {
        this.getOrganizationSettings();
      }

      if (this.isNew) {
        window.document.title = capitalize(i18n.global.t('actions.newAudienceLogic'));
      } else {
        const innerAudienceLogic = await this.getAudienceLogic({ id: this.audienceLogicId });
        // TODO remove the line below when https://hivestack.atlassian.net/browse/TOM-1650 is done
        const keysInLogicalExpression = innerAudienceLogic.logicalExpression.split(/[(,)&|!]+/);
        const audienceRulesInLogicalExpression = innerAudienceLogic.audienceRules.filter(
          (rule) => keysInLogicalExpression.indexOf(rule.key.toString()) > -1,
        );

        const newRules = [];
        let logicalExpression = '';

        for await (const rule of audienceRulesInLogicalExpression) {
          // PredefinedDemographics rules should be combined in one when displaying in the frontend
          if (rule.mode === AudienceRuleModes.PredefinedDemographic) {
            const group = await this.getAudienceRuleCustomGroup({ id: rule.customGroupID });
            const alreadyExistsInNewRules = newRules.find(
              (r) => r.mode === AudienceRuleModes.PredefinedDemographic && r.name === rule.name,
            );

            let lifesightSegment;
            if (this.showPredefinedSegment) {
              const externalId = AudienceSegmentUtils.getSegmentIDFromCustomGroup(group, this.selectedDataProvider);
              const queryParams = new QueryParams(
                1,
                0,
                new FilterCollection([new Filter('external_id', [externalId], FilterComparisonOperator.EQUAL)]),
              );
              queryParams.customQueryParams.dataProviderId = this.dataProviders.find(isLifesightDataProvider).id;
              const res = await queryParams.run(this.getLifesightAudienceSegmentsByOrg);

              lifesightSegment = res.items[0];
            }

            if (alreadyExistsInNewRules && lifesightSegment) {
              alreadyExistsInNewRules.segments.push(lifesightSegment);
            } else {
              newRules.push(
                AudienceRule.fromObject({
                  ...rule,
                  segments: [lifesightSegment],
                }),
              );
            }
          } else if (isExternalSegmentRule(rule.mode)) {
            const group = await this.getAudienceRuleCustomGroup({ id: rule.customGroupID });
            const dataProvider = this.dataProviders.find((dp) => dp.id === innerAudienceLogic.dataProviderId);
            const externalId = AudienceSegmentUtils.getSegmentIDFromCustomGroup(group, dataProvider);
            const queryParams = new QueryParams(
              1,
              0,
              new FilterCollection([new Filter('external_id', [externalId], FilterComparisonOperator.EQUAL)]),
            );
            const { dataProviderID } = innerAudienceLogic;
            queryParams.customQueryParams.dataProviderId = dataProviderID;
            const [res] = await queryParams.run(this.getExternalSegmentsByOrg).then((r) => r.items);

            rule.segments = [res];
            rule.audienceRuleCustomGroup = group;
            newRules.push(rule);
          } else if (rule.customGroupID) {
            rule.audienceRuleCustomGroup = await this.getAudienceRuleCustomGroup({
              id: rule.customGroupID,
            });
            newRules.push(rule);
          } else {
            newRules.push(rule);
          }
        }

        if (newRules.filter((rule) => rule.mode === AudienceRuleModes.PredefinedDemographic).length > 0) {
          // rewrite the logical expression now that predefined demographics rules have been smashed together
          logicalExpression = AudienceSegmentUtils.rewriteLogicalExpression(innerAudienceLogic, newRules);
        } else {
          logicalExpression = innerAudienceLogic.logicalExpression;
        }

        window.document.title = `${window.document.title}: ${innerAudienceLogic.name}`;
        this.entityTimestamp = DateTime.fromISO(innerAudienceLogic.timestamp);
        this.audienceLogic = AudienceLogic.fromObject({
          ...innerAudienceLogic,
          audienceRules: newRules,
          logicalExpression,
        });

        this.$validator.init(this.audienceLogic);
        await this.fetchGeofenceGroups();
        await this.fetchAudienceCustomGroups();
        // Default to lifesight if available
        if (this.showPredefinedSegment) {
          const lifesightDataProvider = this.dataProviders.find(isLifesightDataProvider);
          this.updateAudienceLogicDataProviderID({
            audienceLogic: this.audienceLogic,
            value: lifesightDataProvider.id,
          });
        }

        //
        // When editing, make sure the original object has not changed after the initial load.
        //
        this.didDetectUnexpectedChanges = !this.audienceLogic.isPristine();
        if (this.didDetectUnexpectedChanges) {
          UserNotifications.unexpectedChangeDetected();
        }
      }
    },
    async mounted() {
      if (this.isNew) {
        this.audienceLogic = await this.createNewAudienceLogic();
        this.$validator.init(this.audienceLogic);
      }
      this.geofenceGroups = (
        await this.getGeofenceGroups({
          queryParams: QueryParams.all(new FilterCollection([new Filter('usage_id', [GeofenceGroupType.AUDIENCE])])),
        })
      ).items;

      await waitForPendingQueries([this.dataMarketplaceQuery]);

      try {
        if (
          this.organizationSettings !== null &&
          this.organizationSettings.uiEnableCustomAudienceExternalDemographics
        ) {
          this.externalDemographics = await this.getExternalDemographics(QueryParams.for({ top: null }));
          this.isLoadingDataProviders = true;

          const dataProviderIDs = [...new Set(this.externalDemographics.map((x) => x.dataProviderID))];
          const filteredDataProviders = this.dataProviders.filter(
            (x) => dataProviderIDs.find((y) => y === x.id) !== undefined,
          );

          for await (const dataProvider of filteredDataProviders) {
            const dataProviderExternalDemographics = this.externalDemographics.filter(
              (x) => x.dataProviderID === dataProvider.id,
            );
            await this.updateDataProviderExternalDemographics({
              dataProvider,
              value: dataProviderExternalDemographics,
            });
            this.selectedExternalDemographics[dataProvider] = [];
          }

          // Prioritize data proividers for which the org has external demographics, otherwise just pick the first that is associated to the org
          if (this.audienceLogic != null && !this.audienceLogic.dataProviderID) {
            await this.updateAudienceLogicDataProviderID({
              audienceLogic: this.audienceLogic,
              value: filteredDataProviders.length !== 0 ? filteredDataProviders[0].id : null,
            });
            if (!this.audienceLogic.dataProviderID) {
              await this.updateAudienceLogicDataProviderID({
                audienceLogic: this.audienceLogic,
                value: this.dataProviders.length !== 0 ? this.dataProviders[0].id : null,
              });
            }
          }
        }
      } finally {
        this.isLoadingDataProviders = false;
      }

      GlobalEventBus.$on(GlobalEvents.deleteAudienceRule, (audienceRule) => {
        this.isDeletingAudienceRule = true;
        this.deleteAudienceRule(audienceRule);
        this.isDeletingAudienceRule = false;
      });

      GlobalEventBus.$on(GlobalEvents.audienceLogicExpressionChanged, () => {
        this.updateLogicalExpression();
      });

      GlobalEventBus.$on(GlobalEvents.addAudienceLogicRule, (rule) => {
        this.addAudienceRule(rule);
      });

      GlobalEventBus.$on(GlobalEvents.audienceLogicGeofenceGroupAdded, (geofenceGroupId) => {
        this.updateGeofenceGroup(geofenceGroupId);
      });

      window.addEventListener('scroll', () => {
        this.isFormulaPanelFloating = window.scrollY > 450;
        const pane = this.$refs.formulaPane;
        if (pane != null) {
          this.formulaPaneHeight = pane.clientHeight;
        }
      });
    },
    beforeRouteLeave(to, from, next) {
      if (Math.abs(this.entityTimestamp.diff(this.audienceLogic.timestamp)) < 1000) {
        next();
      } else {
        this.isConfirmLosingChangesModalVisible = true;
        this.confirmLosingChangesCallback = next;
      }
    },
    unmounted() {
      GlobalEventBus.$off('updateAudienceRule');
      GlobalEventBus.$off('audienceLogicGeofenceGroupAdded');
      GlobalEventBus.$off('deleteAudienceRule');
      GlobalEventBus.$off('audienceLogicExpressionChanged');
      GlobalEventBus.$off('addAudienceLogicRule');
      GlobalEventBus.$off('audienceLogicRootNodeChanged');
    },
  };
</script>

<style scoped lang="scss">
  .audience-ai-prompt {
    width: 100%;
    max-width: 72rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;

    & > *:not(.ai-prompt-wrapper) {
      width: fit-content;
    }
  }

  .empty-state {
    .header {
      line-height: 1;
    }
    .badge {
      line-height: 1.5;
    }
    .details {
      max-width: 72rem;
    }
  }
</style>

<style lang="scss">
  @use '@/styles/variables' as *;

  #app {
    .main-content {
      .modal-logic {
        margin-left: 0;
        margin-right: 0;
        width: 100%;
        min-height: 75vh;

        .form-horizontal {
          padding-right: 0 !important;
          padding-bottom: 4rem;

          .form-section-content {
            padding: 0;
          }
        }

        .save-footer {
          position: fixed !important;
          margin-left: 0.3rem !important;
          margin-right: 0.3rem !important;
        }
      }

      &.expanded {
        .well.formula {
          &.floating {
            margin-left: 4.8rem;
          }
        }
      }
    }

    .well.formula {
      font-family: $monospace-font-family;
      transition: box-shadow 0.2s ease-in-out;
      padding-bottom: 0;
      border-radius: 0.8rem;

      background: var(--info);
      color: var(--infoReverse);

      &.floating {
        transition: box-shadow 0.2s ease-in-out;
        position: fixed;
        top: 75px;
        right: 14px;
        left: 14px;
        z-index: 10;
        box-shadow: 0 0.2rem 1.6rem rgba(0, 0, 0, 0.4);
        border: solid 0.1rem rgba(0, 0, 0, 0.15);
        margin-left: 21rem;
      }

      span {
        display: inline-block;
        margin-bottom: 1.2rem;
      }

      .rule {
        background-color: rgba(255, 255, 255, 0.2);
        padding: 0.6rem 1.2rem;
        border-radius: 0.6rem;
      }
    }
  }

  .dataprovider-logo {
    height: 2rem;
  }

  .actions {
    flex-wrap: wrap;
  }

  .archived > svg {
    width: 2rem;
    height: 2rem;
    min-width: 2rem !important;
    min-height: 2rem !important;
    margin: 1rem !important;
  }
</style>
